// removed by extract-text-webpack-plugin
module.exports = {"form":"styles__form___1JRWB","form-input":"styles__form-input___2QJtv","form-textarea":"styles__form-textarea___1eW8f","inputWrapper":"styles__inputWrapper___2Lx9B","inputLabel":"styles__inputLabel___jIIdR","inputElement":"styles__inputElement___5HZ-Y","button":"styles__button___3FgsQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/formBody/styles.css
// module id = 675
// module chunks = 0